import { useQuery } from '@tanstack/react-query';

import { BeraV2Service } from '@/infra/services/bera-v2';
import { QUERY_KEYS } from '@/utils/query-keys';

import type { BeraReportV2Details } from '@/types/Bera';

interface GetBeraReportV2Params {
	id: string;
	organization_id: string;
	company_id: string;
}

const Service = BeraV2Service.getInstance();

export const useGetBeraReportV2 = (params: GetBeraReportV2Params) => {
	return useQuery<BeraReportV2Details>({
		queryKey: [QUERY_KEYS.GET_BERA_REPORT_V2, params],
		queryFn: async () => Service.showReport(params),
		enabled: !!params.id && !!params.organization_id && !!params.company_id
	});
};
